import nookies from 'nookies';
import Constants from '@/constants/const';
/**
 * 获取cookies
 * @param key
 * @param ctx client端为空
 */
export const getCookie = (key: string, ctx?) => {
  const cookies = nookies.get(ctx || {}) || {};
  return cookies[key];
};

export const setCookie = (key: string, value: string, ctx?, config?) => {
  config = config ?? {};
  const cookies =
    nookies.set(ctx, key, value, {
      ...config,
      path: '/',
      secure: true,
      sameSite: 'Lax',
      domain: process.env.DOMAIN_HOST || process.env.NEXT_PUBLIC_DOMAIN_HOST
    }) || {};
  return cookies[key];
};

export const deleteCookie = (key: string, ctx = {}) => {
  nookies.destroy(ctx, key, {
    path: '/',
    secure: true,
    sameSite: 'Lax',
    domain: process.env.DOMAIN_HOST || process.env.NEXT_PUBLIC_DOMAIN_HOST
  });
};

export const getCookies = (ctx?) => {
  return nookies.get(ctx) || {};
};

export const getValueFromCookie = (key: string, ctx?) => {
  return ctx?.req?.[key] || getCookie(key, ctx);
};

export const setCookieToMemory = (key: string, value: string, ctx?, config?) => {
  setCookie(key, value, ctx, config);
  if (ctx) {
    ctx.req[key] = value;
  }
  return value;
};

export const getDeliveryDateFromCookie = (ctx?) => {
  return getValueFromCookie(Constants.DELIVERY_DATE, ctx);
};

export const getZipCodeFromCookie = (ctx?) => {
  return getValueFromCookie(Constants.ZIP_CODE, ctx);
};

export const getLangFromCookie = (ctx?) => {
  return getValueFromCookie(Constants.LANGUAGE, ctx);
};
